import type { Page } from '@shared/types/Tilelist';
import type { IntentResult } from '@shared/types/types.ts';
import { isRankedIntent } from '@shared/types/types.ts';
import type { BracketLayout } from '@tilelist/domain/composition/BracketLayout.ts';

/**
 *
 *
 *
 */
export function getRankedPaging(
    intents: IntentResult[],
    layout: BracketLayout,
    comparisonId: string | undefined,
): Page {
    const rankedIntent = intents.find(isRankedIntent)?.meta;

    return {
        sortiertnach: rankedIntent?.sortOrder ?? '',
        o: rankedIntent?.offset?.toString() ?? '',
        l: layout.layoutParam,
        c: comparisonId ?? '',
    };
}
